import React from 'react';

import AccounTable from './AccounTable';

export default function Accounts() {

  return (
    <div>
        <AccounTable />
    </div>
  )
}
